import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';

import { opacityChange } from '../../../actions';
import { defaultOpacity } from '../../../constants/constants';
import { _ } from '../../../functions/translator';

class OpacitySetting extends React.Component {

    handleOpacityChange = (event, newValue) => {
        this.props.opacityChange(newValue);
    }

    render() {
        return(
            <div>
                <p className='text'>{ _('Opacidad') }</p>
                <Grid container spacing={2}>
                    <Grid item>
                        1%
                    </Grid>
                    <Grid item xs>
                        <Slider
                            min={0.01}
                            max={1}
                            step={0.01}
                            defaultValue={defaultOpacity}
                            value={this.props.opacity}
                            onChange={this.handleOpacityChange}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${Math.round(value*100)}`}
                        />
                    </Grid>
                    <Grid item>
                        100%
                    </Grid>
                </Grid>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        opacity: state.opacity,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        opacityChange : opacityChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(OpacitySetting);